import { useQuery, useMutation, useQueryClient } from "react-query";
import axiosInstance from "./axiosInstance";

const fetchAudit = async (id, page) => {
  if (!id) throw new Error("Client ID is required");

  const params = new URLSearchParams();

  if (page) {
    params.append("page", String(page));
  }

  const response = await axiosInstance.get(
    `/super-admin/client-management/client/${id}/audit-trails?${params}`,
  );

  return response.data?.payload;
};

const truncateAuditTrails = async (clientId) => {
  if (!clientId) {
    throw new Error("Client ID is required");
  }

  const response = await axiosInstance.delete(
    `/super-admin/client-management/client/${clientId}/audit-trails/truncate`,
  );

  return response.data;
};

export const useTruncateAuditTrails = () => {
  const queryClient = useQueryClient();

  return useMutation(truncateAuditTrails, {
    onSuccess: (_, clientId) => {
      queryClient.invalidateQueries(["audit", clientId]);
    },
  });
};

export const useGetAutitTrails = (id, enabled = false, page) => {
  return useQuery(["audit", id, page], () => fetchAudit(id, page), {
    enabled: !!id && enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
